import { motion } from 'framer-motion'
import styled, { css } from 'styled-components'

const AlertStack = styled(motion.div)`
  ${({ theme }) => css`
    position: fixed;
    z-index: 999999;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.1rem;
    width: 100%;
    padding: 0.1rem;

    ${theme.media('sm')} {
      padding: ${theme.spacing(2)};
      gap: ${theme.spacing(2)};
    }
  `}
`

const Alert = styled(motion.div)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
    width: 100%;
    padding: ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(2)};
    background-color: ${theme.palette.white};
    box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.2);

    ${theme.media('sm')} {
      width: fit-content;
      max-width: 60rem;
      border-radius: ${theme.spacing(0.5)};
    }

    &.success .icon {
      color: ${theme.palette.secondary[900]};
    }

    &.error .icon {
      color: #da2f47;
    }

    &.info .icon {
      color: #4c2f82;
    }

    &.warning .icon {
      color: #eba02e;
    }

    > div {
      align-self: center;
      flex-grow: 1;
      display: flex;
      align-items: center;
      gap: ${theme.spacing(2)};

      > svg {
        flex-shrink: 0;
      }
    }

    > button {
      display: flex;
      align-items: center;
      justify-content: center;
      height: ${theme.spacing(4)};
      width: ${theme.spacing(4)};
      appearance: none;
      border: none;
      border-radius: ${theme.spacing(0.25)};
      background-color: transparent;

      &:hover {
        background-color: ${theme.palette.grey[100]};
      }
    }
  `}
`

export default {
  AlertStack,
  Alert,
}
